<template>
  <div class="ticket-container">
    <div class="mb20">
      <el-button type="primary" v-if="columns.length" @click="handleAdd">新增</el-button>
      <el-button type="primary" @click="fetchData">刷新</el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        v-for="col in columns"
        align="center"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"/>
      <el-table-column align="center" label="操作" width="280">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)" :disabled="scope.row.lastIndex !== scope.row.processIndex">编辑</el-button>
          <!-- 删除按钮暂时隐藏 -->
          <el-button
            v-if="false"
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      append-to-body
      width="80%">
      <el-form :inline="true" :model="formData" label-width="80px">
        <el-form-item
          v-for="col in columns"
          :key="col.prop"
          :label="col.label">
          <MaterialLov v-if="col.prop === 'materialName'" :width="col.width" :value="formData.materialId" @callBack="setMaterial"/>
          <el-input v-else style="width: 150px" v-model="formData[col.prop]"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'
import WarehouseLov from "@/views/ticket/lov/WarehouseLov.vue";
import SaleTypeLov from "@/views/ticket/lov/SaleTypeLov.vue";
import MaterialLov from "@/views/ticket/lov/MaterialLov.vue";

export default {
  name: 'Process',
  components: {SaleTypeLov, WarehouseLov,  MaterialLov},
  props: {
    processId: {
      type: Number
    },
    processIndex: {
      type: Number
    },
    isFirstProcess: {
      type: Boolean,
      default: false
    },
    ticketId: {
      type: Number
    },
    typeId: {
      type: Number
    }
  },
  data() {
    return {
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      columns:[],
      tableData: [],
      dialogVisible: false,
      dialogTitle: '新增',
      formData: {},
      typeList: [],
      typeHead: []
    }
  },
  async mounted() {
    await this.fetchData()
    await this.getTypeHead()
    await this.getColumns()
  },
  methods: {
    // 获取数据列表
    async fetchData() {
      try {
        const res = await requestTicket.post('/Ticketing/procedure/execute',
            {procedureName:"get_ticket_line_his_by_process",parameters:[this.processId.toString(),this.ticketId.toString()]}
        )
        console.log(res)
        this.tableData = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    async getColumns() {
      this.columns = this.typeHead.filter(item => item.typeId === this.typeId && item.process && item.process.split(',').includes(this.processId.toString()))
    },
    async getTypeHead() {
      try {
        const res = await requestTicket.post('/Ticketing/ticket-line-head/findAll')
        this.typeHead = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    // 新增操作
    handleAdd() {
      this.formData = {
        ticketType : this.typeId,
        ticketId: this.ticketId,
        processId: this.processId,
        processIndex: this.processIndex,
      }
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },

    // 编辑操作
    handleEdit(row) {
      this.formData = {
        ...row,
        id:row.ticketLineId,
        his_id: row.id
      }
      this.dialogTitle = '编辑'
      this.dialogVisible = true
    },

    // 提交表单
    async submitForm() {
      try {
        await requestTicket.post('/Ticketing/ticket-line/save', this.formData).then(async res => {
          this.$message.success('操作成功')
          await requestTicket.post('/Ticketing/ticket-line-his/save', {
            ...res.data,
            id: this.formData.his_id ? this.formData.his_id : null,
            ticketLineId: res.data.id,
            processId: this.processId,
            processIndex: this.processIndex
          })
          this.dialogVisible = false
          await this.fetchData()
        })
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error('操作失败')
      }
    },
    async commitTicket(row) {
      try {
        await requestTicket.post('/Ticketing/ticket-line-his/save', {
          ...row,
          id: null,
          processId: row.nextProcessId,
          processIndex: row.nextProcessIndex
        })
        this.fetchData()
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error('操作失败')
      }
      this.fetchData()
    },
    async reBackTicket(row) {
      try {
        await requestTicket.delete(`/Ticketing/ticket-line-his/${row.id}`)
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }

    },
    // 删除操作（暂时隐藏）
    async handleDelete(id) {
      try {
        await requestTicket.delete(`/Ticketing/ticket-line/${id}`)
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }
    },
    setMaterial(item){
      console.log("setMaterial", item)
      this.formData.materialId = item.id
      this.formData.materialName = item.name
    }
  }
}
</script>

<style scoped>
.ticket-container {
  padding: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
</style>